<div class="current-schedule-container">
    <div class="current-schedule-body">
        <h1 class="insight-title">{{ eventName }}</h1>
        <p class="event-place">{{ eventPlace }}</p>
        <div class="current-schedule-details">
            <div class="details-item">
                <img src="/assets/img/dueDate.svg" alt="Due Date Icon" />
                <p>
                    Due: <span class="bold-text">{{ dueDate }}</span>
                </p>
            </div>
            <div class="details-item">
                <img src="/assets/img/birdAge.svg" alt="Bird Age Icon" />
                <p>
                    Bird Age: <span class="bold-text">{{ birdAge }}</span>
                </p>
            </div>
            <div class="details-item">
                <img src="/assets/img/defaultPerson.svg" alt="Assigned Person Icon" />
                <p>
                    Assigned to: <span class="bold-text">{{ assignedTo }}</span>
                </p>
            </div>
        </div>
    </div>
    <div class="event-status">{{ eventStatus }}</div>
</div>
